// extracted by mini-css-extract-plugin
export default {"root":"AnimatedComponent__root","currentElement":"AnimatedComponent__currentElement"};